export const LogoIcon = (): JSX.Element => (
  <svg xmlns='http://www.w3.org/2000/svg' width={40} height={40} viewBox='0 0 24 24' fill='none'>
    <path
      d='M13.0932 16.0112H9.87991C9.48976 16.0112 9.12919 15.803 8.93469 15.4652L7.08863 12.2667C6.89412 11.9289 6.89412 11.5126 7.08863 11.1748L8.93469 7.9763C9.12919 7.63848 9.48976 7.43033 9.87991 7.43033H13.092L15.6433 3.01137C15.5887 3.00682 15.5353 3 15.4795 3H7.97356C7.18076 3 6.44825 3.42313 6.05128 4.11014L2.29773 10.6106C1.90076 11.2976 1.90076 12.1427 2.29773 12.8298L6.05128 19.3302C6.44825 20.0173 7.18076 20.4404 7.97356 20.4404H15.4795C15.5353 20.4404 15.5899 20.4336 15.6445 20.429L13.0932 16.01V16.0112Z'
      fill='#e6003d'
    />
    <path
      d='M21.1554 10.6117L17.4018 4.11126C17.3734 4.06349 17.3404 4.01913 17.3097 3.97363L14.7584 8.39259L16.3656 11.1759C16.5601 11.5137 16.5601 11.93 16.3656 12.2678L14.7596 15.05L17.3108 19.469C17.3416 19.4235 17.3745 19.3803 17.4018 19.3325L21.1554 12.832C21.5524 12.145 21.5524 11.2999 21.1554 10.6129V10.6117Z'
      fill='#28f981'
    />
  </svg>
)

export const LogoTextIcon = ({ width = 148 }: { width?: number }): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height='auto'
    viewBox='0 0 148 28'
    fill='none'
  >
    <path
      d='M17.0732 19.8379H12.4255C11.8651 19.8379 11.3378 19.5412 11.0576 19.0468L8.38764 14.4156C8.10746 13.9212 8.10746 13.3278 8.38764 12.8334L11.0576 8.20223C11.3378 7.7078 11.8651 7.41114 12.4255 7.41114H17.0732L20.7649 1C20.6825 1 20.6001 1 20.5342 1H9.65668C8.50301 1 7.44822 1.6098 6.87138 2.61514L1.43263 12.0094C0.855791 12.9982 0.855791 14.2343 1.43263 15.2232L6.87138 24.6503C7.44822 25.6392 8.50301 26.2655 9.65668 26.2655H20.5342C20.6166 26.2655 20.699 26.2655 20.7814 26.2655L17.0896 19.8543L17.0732 19.8379Z'
      fill='#FF0044'
    />
    <path
      d='M28.7582 12.0094L23.3195 2.5822C23.2865 2.51628 23.2371 2.45035 23.1876 2.38443L19.4958 8.79557L21.8197 12.8334C22.0999 13.3279 22.0999 13.9212 21.8197 14.4156L19.4958 18.4535L23.1876 24.8646C23.2371 24.7987 23.2865 24.7328 23.3195 24.6668L28.7582 15.2397C29.335 14.2508 29.335 13.0147 28.7582 12.0259V12.0094Z'
      fill='#28F981'
    />
    <path
      d='M43.9044 21.3211H40.2621V8.25164H35.3342V5.1532H48.8487V8.25164H43.9044V21.3211Z'
      fill='var(--logo-text)'
    />
    <path d='M54.9137 21.3211H51.2714V5.1532H54.9137V21.3211Z' fill='var(--logo-text)' />
    <path
      d='M66.2528 21.5848C63.8136 21.5848 61.8029 20.7938 60.1877 19.1951C58.5726 17.5964 57.7815 15.6022 57.7815 13.196C57.7815 10.7897 58.6055 8.89442 60.2372 7.29576C61.8853 5.6971 63.9289 4.90601 66.4011 4.90601C68.8733 4.90601 70.9334 5.81246 72.7793 7.6089L70.6532 10.2129C69.3512 8.79554 67.9503 8.08685 66.4505 8.08685C64.9508 8.08685 63.9125 8.54832 62.9565 9.48774C62.0006 10.4272 61.5227 11.6468 61.5227 13.1465C61.5227 14.6463 61.6216 14.4156 61.8358 15.0254C62.0336 15.6352 62.3467 16.1791 62.7588 16.657C63.1708 17.135 63.6817 17.5305 64.308 17.8107C64.9178 18.0909 65.643 18.2392 66.4505 18.2392C67.9009 18.2392 69.3018 17.5964 70.6532 16.3274L72.7957 18.6677C70.7851 20.6125 68.5931 21.5848 66.2528 21.5848Z'
      fill='var(--logo-text)'
    />
    <path
      d='M90.3974 21.3211H86.0299L81.3658 14.6957L79.0584 17.2668V21.3376H75.4161V5.1532H79.0584V12.685L85.7662 5.1532H90.0184L83.9204 11.8775L90.4139 21.3211H90.3974Z'
      fill='var(--logo-text)'
    />
    <path
      d='M110.999 21.3211H107.719V10.3942L103.121 19.6895H100.764L96.1494 10.3942V21.3211H92.8696V5.1532H96.9405L101.984 15.0913L106.977 5.1532H111.015V21.3211H110.999Z'
      fill='var(--logo-text)'
    />
    <path d='M118.679 21.3211H115.037V5.1532H118.679V21.3211Z' fill='var(--logo-text)' />
    <path
      d='M133.281 21.3211H122.7V5.1532H126.343V18.1403H133.281V21.3211Z'
      fill='var(--logo-text)'
    />
    <path
      d='M146.466 21.3211H135.885V5.1532H139.528V18.1403H146.466V21.3211Z'
      fill='var(--logo-text)'
    />
  </svg>
)
